// Input masks — display-only; raw digits are what gets submitted.

import { onlyDigits } from '@/lib/strings';

export function maskPhone(value: string): string {
  const digits = onlyDigits(value).slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  // 10 digits = landline (DDD + 4+4); 11 digits = mobile (DDD + 5+4).
  const splitAt = digits.length <= 10 ? 6 : 7;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, splitAt)}-${digits.slice(splitAt)}`;
}

export function maskZipCode(value: string): string {
  const digits = onlyDigits(value).slice(0, 8);
  return digits.length > 5
    ? `${digits.slice(0, 5)}-${digits.slice(5)}`
    : digits;
}

/** Groups the card number in blocks of 4 for display (raw digits are submitted). */
export function maskCardNumber(value: string): string {
  const digits = onlyDigits(value).slice(0, 19);
  return digits.replace(/(.{4})/g, '$1 ').trim();
}

/** Formats the card expiration as MM/AA while typing (raw is MMAA). */
export function maskCardExpiration(value: string): string {
  const digits = onlyDigits(value).slice(0, 4);
  return digits.length > 2
    ? `${digits.slice(0, 2)}/${digits.slice(2)}`
    : digits;
}
